module.exports = __webpack_public_path__ + "static/media/project-diagram.91f6dbcb.svg";